import { PROCESS } from "../../components/Badge/TaskProcessus";

export const _isDirtyForm = ({
    related_user_id,
    assigned_user_id,
    process,
}) => {
    // ******* RELATED TRUE
    if (
        related_user_id.new !== null &&
        related_user_id.new !== undefined &&
        related_user_id.old === null
    ) {
        return true;
    }
    if (related_user_id.new === null) {
        // c'est modifié aussi
        if (related_user_id.new !== related_user_id.old) {
            return true;
        }
    }

    if (related_user_id?.new !== undefined && related_user_id?.old !== null) {
        // donc c'est modifié
        if (parseInt(related_user_id.old) !== related_user_id.new?.id) {
            return true;
        }
    }

    // ******* ASSIGNED_USER
    if (
        assigned_user_id.new !== null &&
        assigned_user_id.new !== undefined &&
        assigned_user_id.old === null
    ) {
        return true;
    }
    if (assigned_user_id.new === null) {
        // c'est modifié aussi
        if (assigned_user_id.new !== assigned_user_id.old) {
            return true;
        }
    }
    if (assigned_user_id?.new !== undefined && assigned_user_id?.old !== null) {
        // donc c'est modifié
        if (parseInt(assigned_user_id.old) !== assigned_user_id.new?.id) {
            return true;
        }
    }

    // ******* PROCESS
    if (
        process.new !== null &&
        process.new !== undefined &&
        process.old === null
    ) {
        return true;
    }

    if (process.new === null) {
        // c'est modifié aussi
        if (process.new !== process.old) {
            return true;
        }
    }

    if (process.new !== undefined && process.old !== null) {
        // get the id of process
        const process_id = PROCESS.find(
            (proc) => proc.content === process?.new
        )?.id;

        if (parseInt(process.old) !== process_id) {
            return true;
        }
    }
    return false;
};
